angular.module('components.caArticleVariantsGridCell', [])
    .component('caArticleVariantsGridCell', {
        templateUrl: 'main/product/articles/article/components/articlevariantsgridcell.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            articleVariant: '=',
            articleVariants: '=',
            articleCollections: '<',
            gridEditType: '<',
            onArticleVariantUpdated: '&',
            changeCount: '=',
            disabled: '<',
            article: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.dataType = '';
    vm.handleMultipleArticleVariants = false;
    vm.inputBoxDisplayValue = '';

    vm.inputValueChanged = inputValueChanged;

    function onInit() {
        if (vm.dataType === undefined || vm.dataType === '') {
            vm.dataType = 'number'; //Default for input fields is number, but datatype for each tab is set in articlevariantsgrid.component.js
        }

        if (vm.articleVariant === undefined && vm.articleVariants.length !== 0) {
            vm.handleMultipleArticleVariants = true;
        } else {
            vm.handleMultipleArticleVariants = false;
        }

        reloadInputBoxValue();

        $scope.$watch(function() { return vm.changeCount; }, function(newValue, oldValue) {
            if (newValue !== oldValue) {
                reloadInputBoxValue();
            }
        });
    }

    function onChanges(changes) {
        if (changes.changeCount) {
            reloadInputBoxValue();
        }
        if (changes.gridEditType) {
            vm.dataType = vm.gridEditType.dataType;
            reloadInputBoxValue();
            if (vm.handleMultipleArticleVariants) {
                vm.inputBoxDisplayValue = undefined;
            }
        }
    }
    function onDestroy() {}

    function reloadInputBoxValue() {
        // "HandleMultipleArticleVariants" indicates that this is the cell that updates multiple values based on some input
        if(vm.handleMultipleArticleVariants || vm.articleVariant === undefined) { return; }

        // Calculated values does not exist on the articleVariant as their own fields
        if (vm.gridEditType.isCalculatedValue) {
            constructCellCalculatedValue();
            return;
        }

        // Actual display value
        if (vm.articleVariant && vm.articleVariant[vm.gridEditType.value]) {
            vm.inputBoxDisplayValue = vm.articleVariant[vm.gridEditType.value];
        }
        // Default values when the actual display value doesn't exist
        else if (vm.dataType === 'number') {
            vm.inputBoxDisplayValue = '0';
        } else if (vm.dataType === 'boolean') {
            vm.inputBoxDisplayValue = false;
        } else if (vm.dataType === 'disabled') {
            vm.inputBoxDisplayValue = '';
        }
    }

    function constructCellCalculatedValue() {
        if (vm.dataType == 'margin') {
            buildAndSetMarginPercentageDisplayData();
        }
    }

    function buildAndSetMarginPercentageDisplayData() {
        if (!vm.articleVariant) { return; }
        vm.inputBoxDisplayValue = `${getMargin()} %`;
    }

    function getMargin() {
        var vatMultiplier = vm.article.vat ? 1 / (vm.article.vat.vatRate + 1) : 1;
        var salesPrice = vm.articleVariant.salesPrice || 0;
        var purchaseCost = vm.articleVariant.purchaseCost || 0;

        if ((!salesPrice && !purchaseCost) || !salesPrice) {
            return 0;
        }

        var brv = (((salesPrice * vatMultiplier) - purchaseCost) / (salesPrice * vatMultiplier)) * 100;

        return brv.toFixed(0);
    }


    function inputValueChanged() {
        if (vm.handleMultipleArticleVariants) {
            _.forEach(vm.articleVariants, function(articleVariant) {
                articleVariant[vm.gridEditType.value] = vm.inputBoxDisplayValue;
            });
        } else {
            vm.articleVariant[vm.gridEditType.value] = vm.inputBoxDisplayValue;
        }
        vm.changeCount += 1;
    }
}
